<template>
  <div class="settings-company">
    <form method="post" @submit.prevent="doSave">
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label for="name">COMPANY NAME <span class="text-danger">*</span></label>
            <input type="text" name="name" id="name"
                   :class="{'form-control': true, 'is-invalid': errors.has('name')}"
                   v-validate.disable="{ required: true }"
                   v-model="name">
            <div class="invalid-feedback">{{ errors.first('name') }}</div>
          </div>
          <div v-if="IS_CLIENT" class="form-group">
            <label for="codename">CLIENT PORTAL URL <span class="text-danger">*</span></label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">{{ OPTIONS.site_url }}/{{ CURRENT_USER.company.id }}/</span>
              </div>
              <input type="text" name="codename" id="codename"
                     :class="{'form-control': true, 'is-invalid': errors.has('codename')}"
                     v-validate.disable="{ required: true, alpha_dash: true }"
                     v-model="codename">
            </div>
            <small class="form-text text-muted">Allow alphabetic characters, numbers, dashes or underscores only</small>
            <div class="invalid-feedback">{{ errors.first('codename') }}</div>
          </div>
          <div v-else>
            <label for="website">WEBSITE</label>
            <input type="text" name="website" id="website" class="form-control" v-model="website">
          </div>
          <div class="form-group">
            <label>CONTACT EMAIL</label>
            <input type="text" class="form-control" v-model="email">
          </div>
          <div class="form-group">
            <label>CONTACT PHONE</label>
            <input type="text" class="form-control" v-model="phone">
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>ADDRESS 1</label>
            <input type="text" class="form-control" v-model="address_1" placeholder="Address line 1...">
          </div>
          <div class="form-group">
            <label>ADDRESS 2</label>
            <input type="text" class="form-control" v-model="address_2" placeholder="Address line 2...">
          </div>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label>SUBURB</label>
                <input type="text" class="form-control" v-model="suburb">
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label>POSTCODE</label>
                <input type="text" class="form-control" v-model="postcode">
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>STATE</label>
            <v-select v-model="state" :options="allStates" class="form-control" :reduce="item => item.code"
                      label="name" :searchable="true" :placeholder="'- Select state'"></v-select>
          </div>
        </div>
      </div>
      <div class="">
        <beat-loader v-if="status == 'saving'"></beat-loader>
        <template v-else>
          <button type="submit" class="btn btn-outline-black">SAVE CHANGES</button>
        </template>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import BeatLoader from 'vue-spinner/src/BeatLoader'
import ServiceUser from '@/services/user'

export default {
  components: {
    BeatLoader,
  },
  data () {
    return {
      status: '',
      name: '',
      codename: '',
      email: '',
      phone: '',
      address_1: '',
      address_2: '',
      suburb: '',
      state: '',
      postcode: '',
      website: ''
    }
  },
  watch: {},
  computed: {
    ...mapGetters(['CURRENT_USER', 'IS_CLIENT', 'OPTIONS']),
    ...mapState({
      allStates: state => state.option.stateOpts
    })
  },
  created () {},
  mounted () {
    this.init();
  },
  methods: {
    init () {
      let self = this;
      if ( !self.CURRENT_USER ) return;

      self.name = self.CURRENT_USER.company.name;
      if (self.IS_CLIENT)
        self.codename = self.CURRENT_USER.company.code;
      else
        self.codename = self.CURRENT_USER.company.codename;
      self.email = self.CURRENT_USER.company.email;
      self.phone = self.CURRENT_USER.company.phone;
      self.address_1 = self.CURRENT_USER.company.address_1;
      self.address_2 = self.CURRENT_USER.company.address_2;
      self.suburb = self.CURRENT_USER.company.suburb;
      self.state = self.CURRENT_USER.company.state;
      self.postcode = self.CURRENT_USER.company.postcode;
      self.website = self.CURRENT_USER.company.website;
    },
    doSave ( ) {
      let self = this;

      if ( self.status == 'saving' ) {
        return;
      }

      self.$validator.validateAll()
        .then(ok => {
          if ( ok ) {
            let postData = {
              name: self.name,
              codename: self.codename,
              email: self.email,
              phone: self.phone,
              address_1: self.address_1,
              address_2: self.address_2,
              suburb: self.suburb,
              state: self.state,
              postcode: self.postcode,
              website: self.website
            };

            self.status = 'saving';

            ServiceUser.saveCompany(postData, company => {
              self.status = '';
              self.$notify({
                type: 'success',
                text: 'Company details saved successfully'
              });

              let user = self.CURRENT_USER;
              user.company = company;

              self.$store.dispatch( 'SET_CURRENT_USER', user );
            }, () => {
              self.status = '';
            });
          }
        });
    }
  }
}
</script>
